import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  Input,
  TemplateRef,
} from '@angular/core';

@Component({
  standalone: false,
  selector: 'fl-section-gallery-item',
  template: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionGalleryItemComponent {
  @Input() src: string;
  @Input() srcTablet?: string;
  @Input() srcDesktop?: string;
  @Input() thumbnailSrc?: string;
  @Input() alt: string;

  isPreviewReady = false;
  isThumbnailReady = false;

  @ContentChild('imageCaption')
  imageCaption: TemplateRef<any>;
}
